import { useState } from 'react';
import { Button } from '@global-ecom/nitro-uds/elements';
import { tw } from 'twind';

import { ScanQRCodeModal } from 'ui/components/ScanQrCodeModal';
import { useBranchFeature } from 'hooks/useBranchFeature';
import { useTranslate } from 'hooks/useTranslations';

import { Link } from './Link';

type PurchaseOnAppCtaProps = {
  className?: string;
  size?: 'sm' | 'base' | 'lg';
};

export const PurchaseOnAppCta = ({
  className,
  size,
}: PurchaseOnAppCtaProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const t = useTranslate();
  const { appLink } = useBranchFeature();

  return (
    <>
      <Link
        className={tw('hidden mobile:flex tablet:flex', className)}
        dataTestId="purchase-on-app-link"
        href={appLink}
        height={size === 'lg' ? 'tall' : undefined}
        as="button"
        variant="black"
        newtab={true}
      >
        {t('purchaseOnApp')}
      </Link>
      <Button
        className={tw('tablet:hidden mobile:hidden', className)}
        dataTestId="purchase-on-app-button"
        label={t('purchaseOnApp')}
        onClick={() => setIsOpenModal(true)}
        size={size}
        variant="primary"
      />
      {isOpenModal && (
        <ScanQRCodeModal onClickOutside={() => setIsOpenModal(false)} />
      )}
    </>
  );
};
